<div id="multimedia-report">

    <h4>Informe Multimedia</h4>

    <div class="mb-3">
        <label for="type-image" class="d-block">
            <input type="radio" class="me-2" name="type" id="type-image" value="image" [(ngModel)]="type">
            <span>Imágenes</span>
        </label>
        <label for="type-video" class="d-block">
            <input type="radio" class="me-2" name="type" id="type-video" value="video" [(ngModel)]="type">
            <span>Videos</span>
        </label>
        <label for="type-all" class="d-block">
            <input type="radio" class="me-2" name="type" id="type-all" value="all" [(ngModel)]="type">
            <span>Ambos</span>
        </label>
    </div>

    <div class="mb-3">
        <button class="btn btn-success" (click)="getMultimedia()">
            <i class="fas fa-photo-video"></i>
            <span>Ver multimedia</span>
        </button>
    </div>

    <div class="mb-3">
        <div *ngIf="multimediaReportLoading">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Cargando...</span>
        </div>
        <div class="text-success" *ngIf="multimediaReportSuccess">
            <i class="fas fa-check"></i>
            <span>Cargado correctamente.</span>
        </div>
        <div class="text-danger" *ngIf="multimediaReportError">
            <i class="fas fa-times"></i>
            <span>Error</span>
        </div>
    </div>

    <table id="multimedia-report-results" *ngIf="multimediaReportSuccess">
        <thead>
            <tr>
                <th>UA / Lección</th>
                <th>Enunciado</th>
                <th>Núm. de videos</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of multimedia">
                <td>UA{{ item.unit_num }} L{{ item.lesson_num }}</td>
                <td>{{ item.heading_name }}</td>
                <td>1</td>
            </tr>
        </tbody>
    </table>

</div>